import { readableColor } from 'polished';
import { colors } from '@ardoq/design-tokens';
import { IconName } from '@ardoq/icons';
import { Bounds } from '@ardoq/graph';
import { BLOCKS_VIEW_URL_ICON_SIZE } from '../../consts';
import type { BlocksViewNode } from '../../types';
import { CanvasRenderingContext } from '../types';
import { rectCenter } from '../../misc/geometry';
import { urlIconRect } from './urlIconRect';
import { drawSpriteIcon } from './drawSpriteIcon';

const urlIconColor = ({ children, open, color }: BlocksViewNode) => {
  const isGroup = children?.length;
  if (!isGroup || !open) {
    return colors.grey500;
  }
  return readableColor(color, colors.grey950, colors.white950);
};
const drawUrlIcon = (
  node: BlocksViewNode,
  cell: Bounds,
  context: CanvasRenderingContext
) => {
  const { urlFieldValues } = node;
  if (!urlFieldValues?.length) {
    return;
  }
  const [x, y] = rectCenter(urlIconRect(node, cell));
  drawSpriteIcon(
    IconName.OPEN_IN_NEW,
    BLOCKS_VIEW_URL_ICON_SIZE,
    urlIconColor(node),
    x,
    y,
    context
  );
};

export { drawUrlIcon };
